export enum RiskStatus {
  Open = 1,
  Closed,
  Pending,
  Rejected
}
export enum RiskScore {
  Low = 1,
  Moderate,
  Medium,
  High,
  Critical
}
